'use client';

import { useEffect } from 'react';
import { ModalService } from '@/shared/ui/modal/ModalService';

/**
 * Opens SetNewPasswordModal when home is reached with ?reset-token=...,
 * the redirect target of /reset-password/[token] (server 307). Mount-only:
 * the 307 is a full page load, so the param is present on first mount.
 */
export const ResetPasswordHandler = () => {
    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get('reset-token');
        if (!token) return;
        window.history.replaceState({}, '', window.location.pathname);
        ModalService.showPrefab('SetNewPasswordModal', { token });
    }, []);

    return null;
};
